export const formatMarketCap = (value?: number) => {
  if (value == null) return undefined;

  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
